var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoldUpArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.708 14.71V5.869L4.845 9.73a.798.798 0 01-1.124 0 .788.788 0 010-1.116l5.217-5.217a.788.788 0 011.116 0l5.217 5.217a.788.788 0 11-1.116 1.116l-3.863-3.863v8.843a.794.794 0 01-.792.791.794.794 0 01-.792-.791z",
    fill: "#58B847",
    stroke: "#58B847",
    strokeWidth: 0.5
  })));
}
export default SvgBoldUpArrow;